import { useQuery } from '@tanstack/react-query';
import { ItemApiClient, ListingApiClient } from 'api';
import { ItemSearchFiltersFormData } from 'components/Form/ItemSearchFiltersForm/ItemSearchFiltersForm';
import { ListingSearchFiltersFormData } from 'components/Form/ListingSearchFiltersForm/ListingSearchFiltersForm';
import { convertSearchFilterDataToQuery, convertListingSearchFilterDataToQuery } from 'utils/search';

export const useItemSearch = (searchFilters?: ItemSearchFiltersFormData, page = 1) => {
  const query = searchFilters ? convertSearchFilterDataToQuery(searchFilters) : {};
  
  return useQuery({
    queryKey: ['items', 'search', { ...query, page }],
    queryFn: () => ItemApiClient.searchItems({ ...query, page }),
    enabled: true,
  });
};

export const useListingSearch = (searchFilters?: ListingSearchFiltersFormData, page = 1) => {
  const query = searchFilters 
    ? { ...convertListingSearchFilterDataToQuery(searchFilters), associate_items: true }
    : { associate_items: true };

  return useQuery({
    queryKey: ['listings', 'search', { ...query, page }],
    queryFn: () => ListingApiClient.searchListings({ ...query, page }),
    enabled: true,
  });
}; 